import React from "react";
import SEO from "../Components/SEO";
import Card2 from "../Images/Headers/publicity_2.jpg";
import "./Article.css";
import Breadcrumb from "react-bootstrap/Breadcrumb";

export function NovelSalesPilot() {
  return (
    <div className="art-page">
      <SEO
        title="Novel Sales Pilot Study — University of California, Berkeley &amp; Innovations for Poverty Action"
        description="CIRCODU partnered with the University of California, Berkeley and Innovations for Poverty Action to implement a ground-breaking randomised study testing whether a novel sales contract could dramatically increase household adoption of energy-efficient cookstoves."
        keywords="Energy efficiency, cookstoves, sales contract, University of California, Berkeley, Innovations for Poverty Action, Uganda, CIRCODU, pilot study, sustainable development, clean cooking, poverty alleviation, durable goods distribution, low-income markets, behavioural barriers, financial barriers, household adoption, energy-efficient technologies, development economics, randomised controlled trials, field research, community engagement, novel sales contract Uganda, cookstove adoption Uganda, energy efficiency Uganda, poverty alleviation Uganda"
        url="/Novel-Sales-Pilot-Study-University-of-California-Berkeley-and-Innovations-for-Poverty-Action"
        datePublished="2011-11-01"
      />

      <div className="art-hero">
        <div className="art-hero__image">
          <img src={Card2} alt="News and Events Header" />
        </div>
        <div className="art-hero__overlay">
          <h4 className="art-hero__label">News &amp; Events</h4>
          <Breadcrumb>
            <Breadcrumb.Item className="text1" href="/">
              Home
            </Breadcrumb.Item>
            <Breadcrumb.Item className="text1">Publicity</Breadcrumb.Item>
            <Breadcrumb.Item
              className="text1"
              href="/publicity/news-and-events"
            >
              News &amp; Events
            </Breadcrumb.Item>
            <Breadcrumb.Item className="text1">
              Novel Sales Pilot Study — UC Berkeley &amp; IPA
            </Breadcrumb.Item>
          </Breadcrumb>
        </div>
      </div>

      <section className="art-section border-bottom">
        <div className="container">
          <div className="art-content">
            <div className="art-date">
              <span className="art-date__dot" />
              November 01, 2011
            </div>
            <h1 className="art-title">
              Novel Sales Pilot Study — University of California, Berkeley &amp;
              Innovations for Poverty Action
            </h1>
            <div className="texty">
              <h2 className="art-subheading">Overview</h2>
              <p>
                Between 2010 and 2011, CIRCODU partnered with the{" "}
                <strong>University of California, Berkeley</strong> and{" "}
                <strong>Innovations for Poverty Action (IPA)</strong> to
                implement a ground-breaking randomised study testing whether a
                novel sales contract could dramatically increase household
                adoption of energy-efficient cookstoves. The research addressed
                one of the most persistent puzzles in development economics: why
                do poor households fail to adopt products that would quickly pay
                for themselves through savings?
              </p>
              <p>
                Innovations for Poverty Action is a global research and policy
                organisation renowned for its use of rigorous randomised
                controlled trials to generate actionable evidence on poverty
                alleviation. The collaboration with CIRCODU brought together
                IPA's methodological rigour and CIRCODU's deep field networks
                and community trust in Uganda.
              </p>
              <h2 className="art-subheading">CIRCODU's Role</h2>
              <p>
                CIRCODU managed all field-based operations for the study, which
                was conducted across hundreds of households and organised
                community groups in Uganda. The novel contract being tested
                combined three elements: a <strong>free trial period</strong>,{" "}
                <strong>rent-to-own payment terms</strong>, and the{" "}
                <strong>right to return the stove</strong> — designed
                specifically to overcome the liquidity constraints, information
                gaps, and risk aversion that typically inhibit adoption of new
                technologies in low-income settings.
              </p>
              <p>
                CIRCODU's field teams organised community sales meetings,
                administered demographic surveys, conducted stove trials,
                collected payment instalments, and tracked whether households
                retained or returned stoves after the trial period. This
                end-to-end operational role required both logistical precision
                and a high degree of community trust built through CIRCODU's
                years of engagement with Ugandan households.
              </p>
              <h2 className="art-subheading">Findings and Impact</h2>
              <p>
                The results were striking. The novel contract dramatically
                increased stove uptake: in urban{" "}
                <strong>Kampala, adoption rose from 4% to 46%</strong>; in rural{" "}
                <strong>Mbarara, from 5% to 57%</strong>. These findings,
                published in leading economics journals, had significant
                implications not just for cookstove programmes but for the
                broader field of durable goods distribution in low-income
                markets — demonstrating that well-designed contract structures
                can overcome the behavioural and financial barriers that prevent
                households from accessing life-improving technologies. CIRCODU's
                field management was central to the quality and credibility of
                this research.
              </p>
            </div>
            <div className="art-cta">
              <p>
                For more information about CIRCODU's research partnerships and
                field study capabilities, contact us at{" "}
                <a href="mailto:info@circodu.org.ug">info@circodu.org.ug</a> or
                call <a href="tel:+256392004309">+256 (0) 392 004 309</a> /{" "}
                <a href="tel:+256782433627">+256 (0) 782 433 627</a>
              </p>
            </div>
            <a href="/publicity/news-and-events" className="art-back">
              ← Back to News &amp; Events
            </a>
          </div>
        </div>
      </section>
    </div>
  );
}
